import React, { useContext, useCallback } from 'react';
import { Button } from 'ui-components/components/button';
import style from '../../../components/grid-header/reusable-grid-button.module.less';
import { PresetGroupsContext } from './context';
import PresetGroupModal from './preset-group-modal';
import { addPresetGroupButton } from './formattedMessageConstants';

export const AddPresetGroupButton = () => {
  const { isModalOpen, setIsModalOpen, selectedPresetId, setSelectedPresetId, needsReload, setNeedsReload } =
    useContext(PresetGroupsContext);
  const openModal = useCallback(() => {
    setIsModalOpen(true);
    setSelectedPresetId();
  }, [setIsModalOpen, setSelectedPresetId]);
  const onClose = useCallback(() => {
    setIsModalOpen(false);
  }, [setIsModalOpen]);
  return (
    <>
      <Button className={style['reusable-button']} onClick={openModal} theme='tertiary'>
        {addPresetGroupButton}
      </Button>
      {isModalOpen && !selectedPresetId && (
        <PresetGroupModal needsReload={needsReload} newPresetGroup onClose={onClose} setNeedsReload={setNeedsReload} />
      )}
    </>
  );
};
